import React from 'react'

export default function Facebook() {
  return (
    <a 
      className="button" 
      id="post-quote" 
      title="Share Page on Facebook!"
      href="https://www.facebook.com/sharer/sharer.php?u=https://sergiocreates.com/random-quote-generator/"
    >
        <i 
          className="fa-brands fa-facebook-f"
        ></i>
      </a>
  )
}
